import axios from "axios";

const xStreamUrlVerify = async (data) => {
  const { URL, Username, Password } = data || {};
  const url = `${URL}/player_api.php?username=${Username}&password=${Password}`;
  const postData = { userid: Username, pwd: Password };
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    try {
      const response = await axios.post(
        `${URL}/player_api.php`,
        JSON.stringify(postData)
      );
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  }
};

export const addxStreamPlaylist = async (xStreamPlaylistURL, data) => {
  try {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => {
      formData.append(key, value);
    });
    const response = await axios.post(xStreamPlaylistURL, formData);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export default xStreamUrlVerify;
